module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-regular.33543c5c.woff2";